@if (diarizable_recordings().length === 0) {
  <p class="panel-empty">No hay grabaciones con diarización disponible.</p>
} @else {
  <mat-form-field appearance="outline" class="recording-select-field">
    <mat-label>Grabación</mat-label>
    <mat-select [value]="selected_recording_id()" (valueChange)="onRecordingSelected($event)">
      @for (recording of diarizable_recordings(); track recording.id) {
        <mat-option [value]="recording.id">{{ recording.concept }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (selected_recording_id() === null) {
    <p class="panel-hint">Selecciona una grabación para ver la diarización.</p>
  } @else if (selected_interventions().length === 0) {
    <p class="panel-empty">Esta grabación no tiene intervenciones diarizadas.</p>
  } @else {
    <div class="interventions-list">
      @for (intervention of selected_interventions(); track $index) {
        <article
          class="intervention-item"
          [class.intervention-item-highlighted]="isInterventionHighlighted($index)"
          [id]="'intervention-readonly-' + $index"
        >
          <div class="intervention-meta">
            <span class="intervention-time">
              {{ formatInterventionTime(intervention.start_seconds) }}
              –
              {{ formatInterventionTime(intervention.end_seconds) }}
            </span>
            <span class="intervention-speaker">{{ intervention.speaker_label }}</span>
            <span class="intervention-user">{{ resolveInterventionUserLabel(intervention) }}</span>
          </div>
          <p class="intervention-text">{{ intervention.text }}</p>
        </article>
      }
    </div>
  }
}
